import { render, staticRenderFns } from "./SupportForm.vue?vue&type=template&id=02d02cc1&"
import script from "./SupportForm.vue?vue&type=script&lang=js&"
export * from "./SupportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports